import React, { FC } from "react";
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import AppPage from "@/ui/AppPage/AppPage";

import dataController from '@/lib/dataController';
import { Permissions } from "@/lib/permissions";
import model from '@/models/poi';
import POIForm from "./POIForm";
import { FormContentMode } from "@/@types/components/formContent";
import { Box } from "@mui/material";

const POIFormPage: FC = () => {
  const { id } = useParams();
  const location = useLocation();

  let viewToOpen = 'none'
  let formToOpen = 'none'
  if(location && location.state) {
    // @ts-ignore
    const { view, form } = location.state;
    viewToOpen = view;
    formToOpen = form;
  } else {
    viewToOpen = 'view';
    formToOpen = 'hgss_user_on_hgss_data';
  }

  const dc = new dataController(model);
  const recordId = parseInt(id ? id : '', 10);

  return (
    <AppPage needPermission={[Permissions.HPSRead, Permissions.HGSSRead]}>
      <Box m={2}>
        <POIForm dc={dc} recordId={recordId} mode={viewToOpen as FormContentMode} form={formToOpen !== null ? formToOpen as string : ''} />  
      </Box>
    </AppPage>
  );
}

export default POIFormPage;
